module.exports = new __parcel__URL__("PublicLinkButtonSpotlight.9320b1e3.svg").toString();